/**
 * Trigger a browser download of a presigned S3 URL via direct navigation.
 * Using fetch() for cross-origin S3 URLs requires CORS; direct anchor navigation does not.
 */
export function downloadPdf(presignedUrl: string, _filename: string): void {
  const a = document.createElement('a');
  a.href = presignedUrl;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/** Trigger a PDF export via API, then download the result. */
export async function exportAndDownload(
  exportFn: () => Promise<{ data?: { url?: string } }>,
  filename: string
): Promise<void> {
  const res = await exportFn();
  const url = res?.data?.url;

  if (!url) {
    throw new Error('Export queued — no immediate URL returned. Check your exports folder.');
  }

  downloadPdf(url, filename);
}
